import { store } from 'redux/store';
import {
  getDocumentReplacedWithTags,
  ReplaceDocumentTagsSources,
} from 'modules/documents/api/replaceDocumentTags';
import { getDocumentBlob } from 'modules/_shared/components/CKEditor/utils/getDocumentBlob';
import { downloadBlob } from 'utils/downloadBlob';

type GenerateDocumentProps = {
  documentId: string;
  documentName: string;
  documentHtml?: string;
  sources: ReplaceDocumentTagsSources;
  language: string;
  footerHtml: string;
  watermarkText?: string;
};

export const generateDocumentWithTags = async ({
  documentId,
  documentName,
  documentHtml,
  sources,
  language,
  footerHtml,
  watermarkText = '',
}: GenerateDocumentProps) => {
  const result = documentHtml
    ? { html: documentHtml }
    : await store.dispatch(
        getDocumentReplacedWithTags({
          documentId,
          sources,
          language,
        })
      );

  const blob = await getDocumentBlob({
    html: result?.html || '',
    footerHtml: footerHtml || '',
    watermarkText,
  });

  downloadBlob(blob, documentName || '');
};
